var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlpLong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33546 1.89027L0.623125 13.3083C0.177226 14.1996 -0.0457241 14.6452 0.00782827 15.0074C0.0545904 15.3238 0.229658 15.6069 0.491833 15.7901C0.792078 16 1.29061 16 2.28767 16H13.7123C14.7094 16 15.2079 16 15.5082 15.7901C15.7703 15.6069 15.9454 15.3238 15.9922 15.0074C16.0457 14.6452 15.8228 14.1996 15.3769 13.3083L9.66455 1.89027C9.1288 0.819399 8.86092 0.283962 8.49843 0.112141C8.18298 -0.0373802 7.81702 -0.0373802 7.50157 0.112141C7.13908 0.283962 6.8712 0.819398 6.33546 1.89027Z",
    fill: "#0ECA82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlpLong);
export default __webpack_public_path__ + "static/media/alp-long.e5a1e1a182eb78058061c9cb48b0126e.svg";
export { ForwardRef as ReactComponent };